import React, { memo, ReactElement } from 'react';

import { Col, Row, TypographyText } from '@components/atoms';
import { ONSET_OPTIONS } from '@constants/text';
import { useReduxForm } from '@hooks/useReduxForm';

function Onset({ value }: { value: string }): ReactElement {
  const { formData, setFormData } = useReduxForm('survey');

  return (
    <Row
      style={{
        width: '100%',
        alignItems: 'center',
        justifyContent: 'flex-start',
        marginBlock: '6px',
        paddingInline: '17px',
        rowGap: '10px',
        columnGap: '8px',
      }}
    >
      {[0, 1, 2, 3, 4].map((e) => (
        <Col
          onClick={() => {
            setFormData({ [value]: { ...formData[value], onset: e } });
          }}
          style={{
            flex: '0 0 calc((100% - 16px) / 3)',
            maxWidth: 'calc((100% - 16px) / 3)',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            height: '50px',
            background: `${formData[value]?.onset === e ? '#d4e8ff' : '#FFFFFF'}`,
            border: `1px solid ${formData[value]?.onset === e ? '#c2d5eb' : '#E5E5E5'}`,
            borderRadius: '12px',
          }}
        >
          <TypographyText yzTypeTypographyText="basic">{ONSET_OPTIONS?.[e]}</TypographyText>
        </Col>
      ))}
    </Row>
  );
}

export default memo(Onset);
